import React from 'react';
import { CTASection } from '../../components/CTASection';
export function AboutCTA() {
  return <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-20" data-id="element-153">
      <CTASection headline="Ready to Build Something Exceptional?" body="We take on new projects through trusted referrals. If you've been referred to us, we'd love to hear about your project." buttonText="Get in Touch" buttonLink="/contact" variant="default" data-id="element-154" />
    </div>;
}